<template>
<div>
    <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'"> {{$t('form.nameplate-picture.prendre_une_photo_de_la_plaque_signaletique')}} </h1>
    <div class="p-6 my-4 bg-white border border-gray-200 shadow my-rounded">
        <div class="font-bold" v-if="selected">
            <div class="flex items-center justify-between">
                <div v-if="selected[0] && selected[0].value">
                    <a class="text-blue-500 hover:underline" target="_blank" :href="selected[0].value.url">
                        <i class="mr-1 fas fa-link"></i> {{$t('form.nameplate-picture.consulter_le_fichier')}}
                    </a>
                </div>
                <button @click="open = !open" class="mt-2 text-gray-900 font-light border border-gray-200 p-1.5 px-3 text-sm rounded-xl hover:bg-gray-100 duration-200">
                    <span class="pl-1">{{$t('form.nameplate-picture.modifier')}}</span>
                </button>
            </div>
            <div v-if="open" class="my-4 border border-b"></div>
        </div>
        <div v-if="open">
            <sav-form v-if="data" :data-src="data" :callback="end" :id="$options.name" />
        </div>
    </div>
</div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'nameplate-picture',
    extends: FormCardExtension,

    methods: {
        async init() {
            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()

            // Init form
            this.data = [
                {
                    type: 'file',
                    required: true
                },
            ]
        },

        end(callbackData) {
            if (callbackData) {
                this.$formTool.addFormData(this.$options.name, callbackData)
                if (this.selected) {
                    this.$emit('update', this.$options.name)
                }
                this.selected = JSON.parse(JSON.stringify(callbackData))
                this.nextBlock = this.$formTool.blockData(this.$options.name).next
            }
        },

        getNextRoute() {
            let blockData = this.$formTool.blockData(this.$options.name)
            return this.selected && this.selected.value == 'no' ? blockData.next.no : blockData.next.yes
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/NamePlatePictureCard.vue